import { fromJS } from 'immutable';
import { DIMENSIONS_UPDATE } from '../../actions';

const initialState = {
  width: -1,
  height: -1,
  top: -1,
  right: -1,
  bottom: -1,
  left: -1
};

function updateDimensions(state, action) {
  let newState = fromJS(state);
  newState = newState.merge(action.data.dimensions);
  return newState.toJS();
}

export default function(state, action) {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case DIMENSIONS_UPDATE:
      return updateDimensions(state, action);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dimensions/index.js